import { Inbox, User, UserX, Archive, Tag as TagIcon } from "lucide-react";
import { useTags } from "@/context/AuthContext";
import { SimulateDialog } from "@/components/inbox/SimulateDialog";

const FILTERS = [
  { id: "all", label: "Tutte", icon: Inbox },
  { id: "mine", label: "Mie", icon: User },
  { id: "unassigned", label: "Non assegnate", icon: UserX },
  { id: "closed", label: "Chiuse", icon: Archive },
];

export const InboxFilters = ({ filter, setFilter, tag, setTag, counts, onCreated }) => {
  const { data: tags = [] } = useTags();
  return (
    <aside className="hidden lg:flex w-60 shrink-0 border-r border-slate-200 bg-white flex-col" data-testid="inbox-filters">
      <div className="h-16 px-5 flex items-center border-b border-slate-200">
        <h2 className="font-bold text-slate-900">Casella condivisa</h2>
      </div>
      <div className="p-3 space-y-0.5">
        {FILTERS.map(({ id, label, icon: Icon }) => {
          const active = filter === id;
          return (
            <button
              key={id}
              data-testid={`inbox-filter-${id}`}
              onClick={() => setFilter(id)}
              className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${active ? "bg-slate-900 text-white font-semibold" : "text-slate-600 hover:bg-slate-100"}`}
            >
              <Icon size={16} />
              {label}
              <span data-testid={`inbox-filter-${id}-count`} className={`ml-auto text-[11px] font-semibold rounded-full px-2 py-0.5 ${active ? "bg-[#25D366] text-slate-900" : "bg-slate-100 text-slate-500"}`}>
                {counts?.[id] ?? 0}
              </span>
            </button>
          );
        })}
      </div>
      <div className="px-5 pt-4 pb-2 text-[10px] uppercase tracking-[0.18em] text-slate-400 font-semibold flex items-center gap-1.5">
        <TagIcon size={11} /> Tag
      </div>
      <div className="px-3 space-y-0.5 flex-1 overflow-y-auto thin-scroll">
        {tags.map((t) => (
          <button
            key={t.id}
            data-testid={`inbox-tag-filter-${t.name.toLowerCase()}`}
            onClick={() => setTag(tag === t.name ? null : t.name)}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${tag === t.name ? "bg-slate-100 text-slate-900 font-semibold ring-1 ring-slate-200" : "text-slate-600 hover:bg-slate-50"}`}
          >
            <span className="w-2.5 h-2.5 rounded-full" style={{ background: t.color }} />
            {t.name}
          </button>
        ))}
      </div>
      <div className="p-3 border-t border-slate-200">
        <SimulateDialog onCreated={onCreated} />
      </div>
    </aside>
  );
};
